import React from 'react'
import { BTitle, BText, BRow, BCol, BLink } from '@prague-digi/ui-components'
import phoneRingImg from '@prague-digi/ui-styles/src/images/nwp-icon/phone-ring.svg'
import bankBranchImg from '@prague-digi/ui-styles/src/images/nwp-icon/bank-branch.svg'
import { compose } from 'recompose'
import { connect } from 'react-redux'

import { intl, IntlInterface } from '../../hoc'
import messages from '../../i18n'
import { modalDialogActions } from '../../redux'
import { SUPPORT_PHONE } from '../../constants/commonConstants'
import { SHOW_NEEDED_DOCS } from '../../constants/modals'
import noSmileImg from '../../assets/noSmile.svg'

import styles from './styles.scss'

interface Props extends IntlInterface {
  description?: any
  note?: any
  showModalDialog: any
  title?: any
}

export const KoDialog: React.FC<Props & IntlInterface> = ({
  description,
  note,
  showModalDialog,
  title,
  translate,
}: Props & IntlInterface) => {
  const goToBranch = () => {
    showModalDialog(SHOW_NEEDED_DOCS)
  }

  return (
    <>
      <div className={styles.errorImageContainer}>
        <img alt="phone" src={noSmileImg} />
      </div>
      <BTitle type="h3" center>
        {translate(title)}
      </BTitle>

      {!!description && (
        <BText center type="primary">
          {translate(description)}
        </BText>
      )}

      <div className={styles.delimiter} />

      <BText center type="notice">
        {translate(note)}
      </BText>

      <div className={styles.actionsContainer}>
        <BRow>
          <BCol
            xs="12"
            sm="6"
            theme="d-flex justify-content-center justify-content-sm-end align-items-start">
            <div className={styles.actionBox}>
              <img alt="phone" src={phoneRingImg} />
              <BText center type="notice" theme={styles.callUs}>
                {translate(messages.errors.scoring.callUs)}
              </BText>
              <BText center type="primary" theme={styles.supportPhone}>
                {SUPPORT_PHONE}
              </BText>
            </div>
          </BCol>
          <BCol
            xs="12"
            sm="6"
            theme="d-flex justify-content-center justify-content-sm-start align-items-start">
            <div className={styles.actionBox}>
              <img alt="phone" src={bankBranchImg} />
              <BText center type="notice" theme={styles.visitUs}>
                {translate(messages.errors.scoring.visitUs)}
              </BText>
              <BLink type="link" onClick={goToBranch} theme={styles.prepareMeeting}>
                {translate(messages.errors.scoring.prepareMeeting)}
              </BLink>
            </div>
          </BCol>
        </BRow>
      </div>
    </>
  )
}

export default compose(
  connect(null, {
    showModalDialog: modalDialogActions.showModalDialog,
  }),
  intl
)(KoDialog)
